<template>
  <ins
    className="adsbygoogle2"
    :style="{
      display: 'block',
      width: '250px',
      border: '1px solid black',
      marginTop: '20px'
    }"
    :data-ad-client="googleAdId"
    data-ad-format="auto"
    data-full-width-responsive="true"
  ></ins>
</template>

<script>
export default {
  name: "GoogleAd",
  data() {
    return {
      googleInit: null,
      googleAdId: "ca-pub-6020787419910581"
    };
  },
  mounted() {
    let timeout = 200;
    this.googleInit = setTimeout(() => {
      if (typeof window !== "undefined")
        (window.adsbygoogle2 = window.adsbygoogle2 || []).push({});
    }, timeout);
  },
  destroyed() {
    if (this.googleInit) clearTimeout(this.googleInit);
  }
};
</script>
